var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM11 14.915V16H9V14.92C6.661 14.553 6 12.918 6 12H8C8.011 12.143 8.159 13 10 13C11.38 13 12 12.415 12 12C12 11.676 12 11 10 11C6.52 11 6 9.12 6 8C6 6.712 7.029 5.416 9 5.085V4.012H11V5.121C12.734 5.531 13.4 6.974 13.4 8H12.4L11.4 8.018C11.386 7.638 11.185 7 10 7C8.701 7 8 7.516 8 8C8 8.374 8 9 10 9C13.48 9 14 10.88 14 12C14 13.288 12.971 14.584 11 14.915Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/leads.eed32b0ed8cf246f3bb18c509020525b.svg";
export { ForwardRef as ReactComponent };